module.exports = __webpack_public_path__ + "img/MNEX25-default-back.333c1173.jpg";